import React from 'react';
import { useParams } from 'react-router-dom';

const useGroupURL = () => {
  const { groupURL } = useParams<{ groupURL: string }>();
  return { groupURL };
};

export default useGroupURL;
